import { useMemo } from "react"
import { useTheme } from "@mui/material"

import type { RecordType, GaugePlotView } from "types/dashboard.types"
import type { GaugeConfig } from "types/gaugePlot.types"

import { gaugeConfig } from "./gauge"

export default function useGaugeConfig(view: GaugePlotView, data: RecordType[]) {
  const { palette } = useTheme()

  const graphConfig: GaugeConfig = useMemo(
    () => gaugeConfig({ view, data, palette }),
    [view, data, palette],
  )

  return graphConfig
}
